/**
 * Il backend può restituire segnalazioni come stringa o come oggetto strutturato.
 * Normalizza per l’uso in JSX (testo).
 */
export function formatSegnalazioneDisplay(seg) {
  if (seg == null) return "";
  if (typeof seg === "string") return seg;
  if (typeof seg === "object" && !Array.isArray(seg)) {
    const tipo = seg.tipo ?? seg.type;
    const descrizione = seg.descrizione ?? seg.description;
    const gravita = seg.gravita ?? seg.severity;
    const parts = [tipo, descrizione, gravita].filter(
      (x) => x !== undefined && x !== null && String(x).trim() !== "",
    );
    if (parts.length > 0) return parts.map((x) => String(x).trim()).join(" — ");
  }
  try {
    return String(seg);
  } catch {
    return "";
  }
}
